// extracted by mini-css-extract-plugin
export var actionButton = "_fh-t";
export var buttonContainer = "_fh-0";
export var buttonContainer2 = "_fh-1";
export var buttonSection = "_fh-2";
export var details = "_fh-3";
export var dropdownItem = "_fh-5";
export var dropdownItemsContainer = "_fh-4";
export var fileInput = "_fh-r";
export var headerButton = "_fh-6";
export var icon = "_fh-7";
export var input = "_fh-8";
export var macroListItem = "_fh-9";
export var mainContent = "_fh-a";
export var microText = "_fh-b";
export var modal = "_fh-w";
export var optionsButton = "_fh-c";
export var paperclip = "_fh-s";
export var pillContent = "_fh-d";
export var preview = "_fh-e";
export var preview2 = "_fh-f";
export var quillEditor = "_fh-q";
export var selectedMacro = "_fh-g";
export var sidebar = "_fh-h";
export var sidebarHeader = "_fh-j";
export var sidebarList = "_fh-i";
export var sidebarListItem = "_fh-k";
export var sidebarSearch = "_fh-l";
export var snoozeDurationWrapper = "_fh-v";
export var statusPillContainer = "_fh-m";
export var tagsContainer = "_fh-n";
export var unselectedMacro = "_fh-o";
export var variable = "_fh-u";
export var wrapper = "_fh-p";